const type = 'OPEN_CARD_TEMPORARY_BLOCK';

const openCardTemporaryBlock = () => ({
  type,
});

export { type };
export default openCardTemporaryBlock;
